<template>
  <div class="units_slider splide">

    <div class="card-title">
      <h3>{{ $t('units') }}</h3>

      <div class="splide__arrows splide__arrows--ltr">
        <button
            class="splide__arrow splide__arrow--prev"
            type="button"
            aria-label="Previous slide"
            aria-controls="splide01-track">
          <TyIcon icon="ty-arrow-left" width="1rem"/>
        </button>
        <button
            class="splide__arrow splide__arrow--next"
            type="button"
            aria-label="Next slide"
            aria-controls="splide01-track">
          <TyIcon icon="ty-arrow-right" width="1rem"/>
        </button>
      </div>
    </div>


    <div class="splide__track">

      <div class="splide__list">

        <div class="splide__slide card-group" v-for="unit in item.units" :key="unit.id" @click="showUnitDetail(unit)"
             itemprop="containsPlace" itemscope itemtype="https://schema.org/HotelRoom">

          <div class="card">
            <div class="card-header">
              <figure class="rooms-photo pointer">
                <picture>
                  <PartsSrcSetImage v-if="unit.hasImage(false)" :image="unit.getTopImage()" :t_type="'thumb_mw'"
                                    :type="'webp'"/>
                  <PartsSrcSetImage v-if="unit.hasImage(false)" :image="unit.getTopImage()" :t_type="'thumb_mw'"
                                    :type="'jpeg'"/>
                  <img v-if="unit.hasImage(false)" :src="unit.getTopImage().getTyrionSrc('thumb_mw')"
                       :alt="unit.getTopImage().title "
                       class="img-cover" loading="lazy"
                       :width="unit.getTopImage().seoWidth('thumb_m')"
                       :height="unit.getTopImage().seoHeight('thumb_m')">
                  <img v-else src="~/assets/img/blank.jpg" :alt="unit.title" class="img-cover" loading="lazy"
                       width="600" height="337">
                </picture>
              </figure>
            </div>

            <div class="card-body px-2 pb-0">

              <div class="room-text">
                <h4 class="h4 d-block mb-1" itemprop="name">{{ unit.title }}</h4>

                <p class="mb-2 text-muted small d-flex-inline" @click="showUnitDetail(unit)" itemprop="description">
                  <span class="text-capitalize">{{$t('for')}} </span>
                  <span>&nbsp;{{unit.getTotalNumberOfGuests() }} {{ $t('hostí')}} - </span>
                  <span v-for="room in unit.rooms">{{ $t('room-type-' + room.type) }}, </span>
                </p>
                <p class="mb text-muted small text-decoration-underline">{{ $t('show-more') }} <TyIcon icon="ty-arrow-right" width=".6rem"/></p>

                <p class="d-none">
                  <span>{{ unit.rooms.length }} {{
                      $t($vysklonujSlovo('izba', unit.rooms.length, 'y', 'ieb'))
                    }}&nbsp;-</span>
                </p>

              </div>

            </div>
          </div>


        </div>
      </div>
    </div>
  </div>


</template>

<script>
import supportsWebP from "supports-webp";
import RoomBedsDescription from "../../../parts/room_beds_description";
import {onMounted} from "vue";
import {useNuxtApp} from "nuxt/app";

const {$splide} = useNuxtApp();


export default {
  components: {RoomBedsDescription},
  props: ['item', 'onClickItem'],
  name: "unit_slider",
  data: function () {
    return {
      units: this.item.units
    }
  },

  async mounted() {
    const Splide = await $splide();
    const splide = new Splide('.units_slider', {
      centered: false,
      type:'slide',
      speed: 300,
      autoplay: 'pause',
      arrows: true,
      draggable: true,
      grabCursor: true,
      gap: '1rem',
      pagination: false,


      breakpoints: {
        '320': {
          perPage: 1,

        },
        '640': {
          perPage: 1,

        },
        '768': {
          perPage: 2,

        },
        '1024': {
          perPage: 2,

        },
        '9999': {
          perPage: 2,
          padding: { left: '0rem', right: '0rem' },
          arrows: this.units.length >= 2,
          type:'slide',
        },
      }
    }).mount();
  },
  methods: {
    hrefTarget: function () {
      return this.$store.state.device === 'desktop' ? "_blank" : "_self"
    },
    showWebp: async function () {
      return await supportsWebP;
    },
    showUnitDetail: function (unit) {
      this.onClickItem(unit, null);
    }
  }

}
</script>
